<div
  [ngClass]="{
    'bg-red-50 border-red-200': isMissing,
    'bg-blue-50 border-blue-200': !isMissing,
  }"
  class="rounded-lg p-6 shadow-sm border"
>
  <div class="flex mb-4">
    <div class="flex flex-col">
      <div
        class="font-bold rounded-full w-8 h-8 flex items-center justify-center mr-3"
        [ngClass]="{
          'bg-red-100 border-red-200': isMissing,
          'bg-blue-100 text-blue-700': !isMissing,
        }"
      >
        {{ question.index_number }}
      </div>
    </div>
    <h2 class="text-lg font-semibold">
      <span [innerHTML]="questionHtml | safeHtml"></span>
    </h2>
  </div>
  <div class="space-y-4 px-10">
    <div *ngFor="let answer of question.answers" class="quiz-option flex items-start gap-3 mb-4">
      <div class="relative flex items-start justify-start">
        <input
          type="checkbox"
          [id]="'checkbox-' + answer.uuid"
          [value]="answer.uuid"
          (change)="handleCheckboxChange(answer.uuid, answer.is_correct === true)"
          [checked]="selectedValues.includes(answer.uuid)"
          class="appearance-none h-5 w-5 border-2 border-blue-300 rounded checked:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all cursor-pointer"
        />
      </div>
      <div class="flex flex-col flex-1">
        <label
          [for]="'checkbox-' + answer.uuid"
          class="cursor-pointer select-none block leading-6 break-words"
        >
          {{ answer.answer }}
        </label>

        <div
          *ngIf="answer.is_correct && selectedValues.includes(answer.uuid)"
          class="mt-2 sm:mt-0 flex-1"
        >
          <input
            type="text"
            [(ngModel)]="otherInputs[answer.uuid]"
            (input)="updateOtherText(answer.uuid, otherInputs[answer.uuid])"
            placeholder="Please specify..."
            class="px-3 py-1 placeholder-slate-300 text-slate-600 bg-white rounded text-sm border border-slate-300 outline-none focus:outline-none focus:ring w-full max-w-md"
          />
        </div>
      </div>
    </div>
  </div>
</div>
